import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./stats.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";

export const ElearningHomeStats = () => {
  return (
    <section className={styles.section_stats}>
      <div className="container">
        <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
          <Grid item xs={12} sm={12} md={6}>
            <div className={styles.heading_wrapper}>
              <p className={styles.sub_text}>
                Your Dream University is Not a Dream Anymore
              </p>
              <h2 className={styles.heading}>
                5000+ Students have made it to their dream universities with us
              </h2>
              <h3 className={styles.sub_heading}>Now it’s your turn!</h3>
            </div>
            <div className={styles.btn_wrapper}>
              <Link legacyBehavior href="#">
                <a className={`btn btn-secondary btn-xl ${styles.link_btn}`}>
                  Book Your 30 Mins Call Now
                </a>
              </Link>
              <Link legacyBehavior href="#">
                <a className={`btn btn-grey-border btn-bg ${styles.link_btn}`}>
                  Explore More
                </a>
              </Link>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Grid container spacing={{ xs: 2, sm: 3, md: 3 }}>
              <Grid item xs={12} sm={6} md={6}>
                <div className={`${styles.count_card} ${styles.count_card_1}`}>
                  <ReactSVG
                    src={getAssets("assets/images/elearning/home/network.svg")}
                  />
                  <div className={styles.count_num}>
                    <span>300</span>
                    <span>+</span>
                  </div>
                  <div className={styles.count_text}>
                    Offers from Ivy-League Universities
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <div className={`${styles.count_card}`}>
                  <ReactSVG
                    src={getAssets(
                      "assets/images/elearning/home/student-with-hat.svg"
                    )}
                  />
                  <div className={styles.count_num}>
                    <span>1000</span>
                    <span>+</span>
                  </div>
                  <div className={styles.count_text}>
                    Offers from top global universities
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <div className={`${styles.count_card}`}>
                  <ReactSVG
                    src={getAssets(
                      "assets/images/elearning/home/student-group.svg"
                    )}
                  />
                  <div className={styles.count_num}>
                    <span>50</span>
                    <span>+</span>
                  </div>
                  <div className={styles.count_text}>
                    Internationally trained counsellors
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <div className={`${styles.count_card} ${styles.count_card_4}`}>
                  <ReactSVG
                    src={getAssets(
                      "assets/images/elearning/home/video-call.svg"
                    )}
                  />
                  <div className={styles.count_num}>
                    <span>2000</span>
                    <span>+</span>
                  </div>
                  <div className={styles.count_text}>Mentors</div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningHomeStats;
